"use client";

import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Camera, Video, Image } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceOptions() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: Camera,
    title: "Photography Only",
    description: "Timeless images, without the stiffness.  \nThis is for couples who want photographs that feel natural and honest. We document the day as it happens, the glances, the chaos, the calm, without pulling you away for endless posing. ",
    delay: "0ms",
    buttonText: "Get Your Photography Package"
  }, {
    icon: Video,
    title: "Videography Only",
    description: "Some moments need movement, sound, and pacing to truly live again. This option is for couples who want their wedding remembered as it felt, not just how it looked. We focus on story, emotion, and flow, capturing the vows, speeches, laughter, and quiet in-between moments that still photos can't hold on to",
    delay: "150ms",
    buttonText: "Get Your Videography Package"
  }, {
    icon: Image,
    title: "Photography & Videography Combined",
    description: "One story, told properly.\nWhen photo and video are captured together, the story is stronger. The timing aligns, the energy matches, and nothing important slips through the cracks. Our team works as one, not as two separate vendors competing for time and space.\n",
    delay: "300ms",
    buttonText: "Get Your Combined Package"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-24 px-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-display text-4xl md:text-5xl text-foreground mb-4">
            How you can work with us
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const isVisible = visibilities[i];
          const ref = refs[i];
          return <div key={i} data-index={i} ref={ref} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: `opacity 150ms ease-out ${service.delay}, transform 150ms ease-out ${service.delay}`
          }}>
                <Card className="h-full flex flex-col border border-border shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[150ms] ease-[cubic-bezier(0.22,1,0.36,1)]">
                  <CardContent className={`flex-1 flex flex-col items-center text-center pt-8 ${i === 0 || i === 1 || i === 2 ? 'bg-cover bg-center relative' : ''} ${i === 0 ? 'bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_9kukk5t9.jpg)]' : ''} ${i === 1 ? 'bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/image_vqgu6qhw.jpg)]' : ''} ${i === 2 ? 'bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/combined_photo_video_wedding_service.png)]' : ''}`}>
                    {(i === 0 || i === 1 || i === 2) && <div className="absolute inset-0 bg-black/40 rounded-t-xl"></div>}
                    <div className={`mb-6 transition-transform duration-[120ms] ease-[var(--ease-spring)] hover:scale-105 ${i === 0 || i === 1 || i === 2 ? 'relative z-10' : ''}`}>
                      <Icon className={`size-16 ${i === 0 || i === 1 || i === 2 ? 'text-white' : 'text-[#B86A5A]'}`} strokeWidth={1.5} />
                    </div>
                    <h3 className={`font-display text-2xl mb-4 ${i === 0 || i === 1 || i === 2 ? 'text-white relative z-10' : 'text-foreground'}`}>
                      {service.title}
                    </h3>
                    <p className={`leading-relaxed ${i === 0 || i === 1 || i === 2 ? 'text-white relative z-10' : 'text-muted-foreground'}`}>
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="justify-center pb-8">
                    <Button asChild className="bg-[#B86A5A] text-white hover:bg-[#A55A4A] focus-visible:ring-[#B86A5A]/40">
                      <Link to="mailto:aidan.bartlett.photography@gmail.com">{service.buttonText}</Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}